/** The API's refusal codes for custom patient fields, and the i18n key that explains each. */

export const CUSTOM_FIELD_ERRORS: Record<string, string> = {
    custom_field_label_required: "center.patientFields.errors.labelRequired",
    custom_field_label_too_long: "center.patientFields.errors.labelTooLong",
    custom_field_label_taken: "center.patientFields.errors.labelTaken",
    custom_field_type_invalid: "center.patientFields.errors.typeInvalid",
    custom_field_options_invalid: "center.patientFields.errors.optionsInvalid",
    custom_field_limit_reached: "center.patientFields.errors.limitReached",
    custom_field_values_not_unique: "center.patientFields.errors.valuesNotUnique",
    custom_field_not_found: "center.patientFields.errors.notFound",
    custom_field_value_invalid: "center.patientFields.errors.valueInvalid",
    custom_field_value_too_long: "center.patientFields.errors.valueTooLong",
    custom_field_required_missing: "center.patientFields.errors.requiredMissing",
    custom_field_value_taken: "center.patientFields.errors.valueTaken",
    patient_not_found: "center.patientFields.errors.patientNotFound",
};

export interface CustomFieldRefusal {
    /** The i18n key of what to say. */
    message: string;
    /** The field the refusal is about, when the server names one. */
    fieldId?: string;
}

/** What a refused write says, and — for a value — which field it is about. */
export function customFieldRefusal(error: unknown): CustomFieldRefusal {
    const data = (error as { response?: { data?: { detail?: unknown; field_id?: unknown } } })?.response?.data;
    const code = typeof data?.detail === "string" ? data.detail : undefined;
    return {
        message: (code && CUSTOM_FIELD_ERRORS[code]) || "center.patientFields.errors.generic",
        fieldId: typeof data?.field_id === "string" ? data.field_id : undefined,
    };
}
